<template>
  <v-dialog
    v-model="showDialogConfirmation"
    persistent
    scrollable
    max-width="600">
    <v-card>
      <v-card-title style="color: var(--v-primary-base); box-shadow: 1px 1px 5px 3px color-mix(in srgb, var(--v-shadow-base) 50%, transparent);">
        <v-row>
          <v-col cols="12" class="text-center">
            Atenção
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pt-5">
        {{ textDialog }}
      </v-card-text>
      <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn
          class="btn-quote"
          large
          width="130"
          @click="onClickCancel()">
          <v-icon left>fas fa-times</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          class="btn-quote"
          large
          width="130"
          @click="onClickConfirm()">
          <v-icon left>fas fa-check</v-icon>
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirmationDialog',
  data: () => ({
    showDialogConfirmation: false,
  }),
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    textDialog: {
      type: String,
      default: 'Deseja realmente continuar?'
    }
  },
  watch: {
    showDialog(newValue) {
      this.showDialogConfirmation = newValue;
    }
  },
  methods: {
    onClickCancel() {
      this.showDialogConfirmation = !this.showDialogConfirmation;
      this.$emit('onClickCancelDialog');
    },
    onClickConfirm() {
      this.$emit('onClickConfirmDialog');
      this.showDialogConfirmation = !this.showDialogConfirmation;
    }
  },
  created() {},
};
</script>

<style scoped>
</style>
